
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checked: this.isChecked
    }
  },
  methods: {
    toggleCheck () {
      this.checked = !this.checked
      this.$emit('onChecked', { checked: this.checked, value: this.value || '' })
    }
  }
}
